<template>
  <Button
    data-slot="carousel-next"
    :disabled="!canScrollNext"
    :class="
      cn(
        'tw:touch-manipulation tw:absolute tw:size-8 tw:rounded-full tw:p-0',
        orientation === 'horizontal'
          ? 'tw:-right-12 tw:top-1/2 tw:-translate-y-1/2'
          : 'tw:-bottom-12 tw:left-1/2 tw:-translate-x-1/2 tw:rotate-90',
        props.class,
      )
    "
    variant="outline"
    size="icon"
    @click="scrollNext"
  >
    <slot>
      <ArrowRight class="tw:icon-action" />
      <span class="tw:sr-only">{{ t('common.nextImage') }}</span>
    </slot>
  </Button>
</template>

<script setup>
// 1. Import necessary components
defineOptions({ name: 'UiCarouselNext' });
import { ArrowRight } from '@lucide/vue';
import { useI18n } from 'vue-i18n';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utilities/classes';
import { useCarousel } from './useCarousel';

// 2. Use
const props = defineProps({
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const { canScrollNext, orientation, scrollNext } = useCarousel();
const { t } = useI18n();
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
